import { render } from "./ConfirmDeletion.vue?vue&type=template&id=c187f3f2"
import script from "./ConfirmDeletion.vue?vue&type=script&lang=js"
export * from "./ConfirmDeletion.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__